import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
${({ displayState }) => css`
  display: flex;
  flex-direction: column;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #E3E3E3 transparent;
  flex-grow: ${displayState?.flexGros ?? ''};

  width: 100%;
  height: ${displayState?.height ?? '100%'};
  min-height: ${displayState?.minHeight ?? ''};

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  @media only screen and (min-width: 768px) {

    ::-webkit-scrollbar {
      width: 16px;
      height: 16px;
      background: transparent;
    }

    ::-webkit-scrollbar-track-piece  {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb:vertical {
      background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:horizontal {
      background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
  }
`}
`;

export default Wrapper(template);